// Types
import { RootState } from 'types/RootState.types';

export default function showMinimalSaveOrder(state: RootState): boolean | undefined {
  return !state.user?.validSession && state.user?.claimOrderCallbackHappened;
}
